<template>
  <div id="login">
    <AccountApp />
    <Refresh />
  </div>
</template>

<script>
import AccountApp from "@/components/AccountApp";
import Refresh from "@/components/Refresh";
export default {
  name: "LOGIN",
  components: {
    AccountApp,
    Refresh
  }
};
</script>
